import { motion } from "framer-motion";

export default function LoadingSkeleton() {
  return (
    <div className="bg-white rounded-xl p-4 shadow-soft">
      <div className="space-y-4">
        {/* Image skeleton */}
        <div className="relative aspect-[3/4] rounded-lg bg-gray-200 overflow-hidden">
          <motion.div
            className="absolute inset-0 -inset-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
            animate={{
              x: ["0%", "200%"],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        </div>

        {/* Title skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded-full w-3/4">
            <motion.div
              className="h-full -inset-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
              animate={{
                x: ["0%", "200%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "linear",
                delay: 0.2,
              }}
            />
          </div>
          <div className="h-4 bg-gray-200 rounded-full w-1/2">
            <motion.div
              className="h-full -inset-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
              animate={{
                x: ["0%", "200%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "linear",
                delay: 0.4,
              }}
            />
          </div>
        </div>

        {/* Price and button skeleton */}
        <div className="flex justify-between items-center pt-2">
          <div className="h-6 bg-gray-200 rounded-full w-1/3">
            <motion.div
              className="h-full -inset-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
              animate={{
                x: ["0%", "200%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "linear",
                delay: 0.6,
              }}
            />
          </div>
          <div className="h-10 w-10 bg-gray-200 rounded-full">
            <motion.div
              className="h-full -inset-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent"
              animate={{
                x: ["0%", "200%"],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "linear",
                delay: 0.8,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
